// React
import React, { createContext, useEffect, useState } from 'react';

// Components
import Loader from '../components/Loader/Loader';

export const GlobalContext = createContext()

const GlobalContextProvider = (props) => {
    const [ user, setUser ] = useState(null);
    const [ isAuthReady, setIsAuthReady ] = useState(false);
    const [ currentModule, setCurrentModule ] = useState(null);
    const [ isLoading, showLoader ] = useState(false);

    useEffect(() => {
        const restoreSession = async () => {
            const storedUser = localStorage.getItem('user');
            if (!storedUser) {
                setIsAuthReady(true);
                return;
            }

            try {
                const cachedUser = JSON.parse(storedUser);
                if (!cachedUser.access_token) {
                    throw new Error('Missing access token');
                }

                const httpResponse = await fetch(
                    process.env.REACT_APP_API_BASE_URL + '/admin/session',
                    {
                        headers: {
                            Authorization: 'Bearer ' + cachedUser.access_token
                        }
                    }
                );
                const response = await httpResponse.json();

                if (!httpResponse.ok || response.status !== 'success') {
                    throw new Error('Invalid session');
                }

                const restoredUser = {
                    ...cachedUser,
                    ...response.data.user,
                    access_token: cachedUser.access_token
                };
                localStorage.setItem('user', JSON.stringify(restoredUser));
                setUser(restoredUser);
            }
            catch (error) {
                localStorage.removeItem('user');
                setUser(null);
            }
            finally {
                setIsAuthReady(true);
            }
        };

        restoreSession();
    }, []);

    return (
        <GlobalContext.Provider value={{ user, setUser, isAuthReady, currentModule, setCurrentModule, isLoading, showLoader }}>
            { isLoading && (<Loader />) }
            { props.children }
        </GlobalContext.Provider>
    )
}
export default GlobalContextProvider
